import { GridFilterItem } from '@mui/x-data-grid-pro';

import { QueryOption } from '../@types';
import { httpClient, HttpMethod } from './http-client';
import { TemplateResponse, TLCExecuteDataType, TlcTemplatesListResponse, TemplateActionType, TLCTemplateDetailsDataType } from '../@types/tlc.type';

export interface TlcExecuteResponse {
  success: boolean;
  message?: string;
}

export const getTlcTemplates = (queryOptions: QueryOption): Promise<TlcTemplatesListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/tlc/templates?limit=${pageSize}&page=${page + 1}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel.items?.forEach((filter: GridFilterItem) => {
    const field = filter?.field;
    const operator = filter?.operator;
    const value = filter?.value ?? '';
    url += `&${field}=${operator},${value}`;
  });

  return httpClient<TlcTemplatesListResponse>(url, HttpMethod.Get);
};

export const createTLCTemplate = (templateData: TemplateResponse): Promise<TemplateResponse> => {
  return httpClient<TemplateResponse>('/actionTemplate', HttpMethod.Post, templateData);
};

export const updateTLCTemplate = (id: number, updatedTemplateData: TemplateResponse): Promise<TemplateResponse> => {
  return httpClient<TemplateResponse>(`/actionTemplate/${id}`, HttpMethod.Put, updatedTemplateData);
};

export const getTLCTemplateById = (id: number): Promise<TemplateResponse> => {
  return httpClient<TemplateResponse>(`/actionTemplate/${id}`, HttpMethod.Get);
};

export const getTemplateActionTypes = (): Promise<TemplateActionType[]> => {
  return httpClient<TemplateActionType[]>('/templateActionTypes', HttpMethod.Get);
};

export const getTlcTemplateDetails = (): Promise<TLCTemplateDetailsDataType[]> => {
  return httpClient<TLCTemplateDetailsDataType[]>('/tlc/templateDetails', HttpMethod.Get);
};

export const executeTlcTransactions = (tlcExecuteType: TLCExecuteDataType): Promise<TlcExecuteResponse> => {
  return httpClient<TlcExecuteResponse>('/tlc/executeTransactions', HttpMethod.Post, tlcExecuteType);
};
